/**
 * @generated SignedSource<<1b953b2e0429143f0d58c7d6da869198>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LinkRelationshipTypeCell_fieldRef$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef">;
  readonly " $fragmentType": "LinkRelationshipTypeCell_fieldRef";
};
export type LinkRelationshipTypeCell_fieldRef$key = {
  readonly " $data"?: LinkRelationshipTypeCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkRelationshipTypeCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "LinkRelationshipTypeCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "d578072335177caee364c62a456b138e";

export default node;
